module.exports = __webpack_public_path__ + "static/media/29FUNOV8.2a9d8431.jpg";